import { IJobrole } from "../model/top.model";

export enum OS_TYPE {
  WEB = 0,
  ANDROID = 1,
  IOS = 2,
}

export enum LOGIN {
  LOGIN_OBJECT = "loginObject",
  USER_SETTINGS = "userSettings",
  JWT_TOKEN = "jwtToken",
  USER_NAME = "userName",
  PASS_WORD = "passWord",
  AGREE = "agree",
  LOGGIN_ATTEMPTS = "loginAttempts",
  HAS_LOGGED_IN = "hasLoggedIn",
}

export enum Gender {
  unknown = 0,
  male = 1,
  female = 2,
}

export enum EditMode {
  browse = 0,
  edit = 1,
  new = 2,
  readonly = 3,
}

export enum TimeRegistrationType {
  OpbouwTijdVoorTijd = 0,
  VerlofADV = 1,
  VerlofSpeciaal = 2,
  VerlofVrijeDag = 3,
  FeestDag = 4,
  OpnameTijdVoorTijd = 10,
  Ziek = 50,
  DokterTandarts = 51,
  Projecten = 101,
  projectenWVB = 102,
  Tekenwerk = 103,
  Planning = 104,
  Verkoopactiviteit = 105,
  Werkbespreking = 106,
  Vergadering = 107,
  MT = 108,
  DT = 109,
  Bestellingen = 110,
  Administratie = 111,
  Secretarieel = 112,
  Automatisering = 113,
  Dossierbeheer = 114,
  Personeel = 115,
  Studie = 116,
  Overig = 117,
  Verhuur = 118,
  ProjectNCC = 119,
  projectTOP = 120,
  projectService = 121,
  Service = 201,
  Transport = 202,
  Reisuren = 203,
  Schoonmaak = 204,
  Scholing = 300,
  NietGewerkt = 301,
}

export enum TimeRegistrationStatus {
  empty = -1,
  all = 0,
  open = 1,
  submitted = 2,
  rejected = 3,
  checked = 4,
  approved = 5,
  done = 6,
  mine = 7,
}

export enum Jobrole {
  administrator = 1,
  directie = 2,
  management = 3,
  loonadministratie = 4,
  fiatteur = 5,
  administratie = 6,
  secretariaat = 7,
  verkoop = 8,
  productinnovatie = 9,
  werkvoorbereiding = 10,
  service_onderhoud = 11,
  transport_plaatsen = 12,
  verhuur_projecten = 13,
  facilitair = 14,
  voorman = 15,
  productie = 16,
  urencontrole = 17,
}

export const jobRoles: IJobrole[] = [
  {
    id: Jobrole.administrator.toString(),
    Jobrole: Jobrole.administrator,
    description: "Administrator",
    timeRegistrationTypes: [],
  },
  {
    id: Jobrole.directie.toString(),
    Jobrole: Jobrole.directie,
    description: "Directie",
    timeRegistrationTypes: [
      TimeRegistrationType.Vergadering,
      TimeRegistrationType.Dossierbeheer,
      TimeRegistrationType.MT,
      TimeRegistrationType.DT,
      TimeRegistrationType.Personeel,
      TimeRegistrationType.Overig,
      TimeRegistrationType.Studie,
    ],
  },
  {
    id: Jobrole.management.toString(),
    Jobrole: Jobrole.management,
    description: "Management",
    timeRegistrationTypes: [
      TimeRegistrationType.Vergadering,
      TimeRegistrationType.Dossierbeheer,
      TimeRegistrationType.MT,
      TimeRegistrationType.Overig,
      TimeRegistrationType.Studie,
    ],
  },
  {
    id: Jobrole.loonadministratie.toString(),
    Jobrole: Jobrole.loonadministratie,
    description: "Loonadministratie",
    timeRegistrationTypes: [
      TimeRegistrationType.Administratie,
      TimeRegistrationType.Personeel,
      TimeRegistrationType.Vergadering,
      TimeRegistrationType.Secretarieel,
      TimeRegistrationType.Overig,
      TimeRegistrationType.Studie,
    ],
  },
  {
    id: Jobrole.fiatteur.toString(),
    Jobrole: Jobrole.fiatteur,
    description: "Fiatteur",
    timeRegistrationTypes: [
      TimeRegistrationType.Vergadering,
      TimeRegistrationType.Dossierbeheer,
      TimeRegistrationType.Personeel,
      TimeRegistrationType.Overig,
      TimeRegistrationType.Studie,
    ],
  },
  {
    id: Jobrole.administratie.toString(),
    Jobrole: Jobrole.administratie,
    description: "Administratie",
    timeRegistrationTypes: [
      TimeRegistrationType.Administratie,
      TimeRegistrationType.Vergadering,
      TimeRegistrationType.Secretarieel,
      TimeRegistrationType.Overig,
      TimeRegistrationType.Studie,
    ],
  },
  {
    id: Jobrole.secretariaat.toString(),
    Jobrole: Jobrole.secretariaat,
    description: "Secretariaat",
    timeRegistrationTypes: [
      TimeRegistrationType.Planning,
      TimeRegistrationType.Vergadering,
      TimeRegistrationType.Bestellingen,
      TimeRegistrationType.Overig,
      TimeRegistrationType.Studie,
    ],
  },
  {
    id: Jobrole.verkoop.toString(),
    Jobrole: Jobrole.verkoop,
    description: "Verkoop",
    timeRegistrationTypes: [
      TimeRegistrationType.projectTOP,
      TimeRegistrationType.projectService,
      TimeRegistrationType.ProjectNCC,
      TimeRegistrationType.Verhuur,
      TimeRegistrationType.Overig,
    ],
  },
  {
    id: Jobrole.productinnovatie.toString(),
    Jobrole: Jobrole.productinnovatie,
    description: "Productinnovatie",
    timeRegistrationTypes: [
      TimeRegistrationType.projectenWVB,
      TimeRegistrationType.Tekenwerk,
      TimeRegistrationType.Verkoopactiviteit,
      TimeRegistrationType.Vergadering,
      TimeRegistrationType.Bestellingen,
      TimeRegistrationType.Overig,
      TimeRegistrationType.Studie,
    ],
  },
  {
    id: Jobrole.werkvoorbereiding.toString(),
    Jobrole: Jobrole.werkvoorbereiding,
    description: "Werkvoorbereiding",
    timeRegistrationTypes: [
      TimeRegistrationType.Vergadering,
      TimeRegistrationType.Werkbespreking,
      TimeRegistrationType.Tekenwerk,
      TimeRegistrationType.projectenWVB,
      TimeRegistrationType.Overig,
      TimeRegistrationType.Studie,
    ],
  },
  {
    id: Jobrole.service_onderhoud.toString(),
    Jobrole: Jobrole.service_onderhoud,
    description: "Service/Onderhoud",
    timeRegistrationTypes: [
      TimeRegistrationType.Vergadering,
      TimeRegistrationType.Werkbespreking,
      TimeRegistrationType.Planning,
      TimeRegistrationType.Service,
      TimeRegistrationType.Overig,
      TimeRegistrationType.Studie,
    ],
  },
  {
    id: Jobrole.transport_plaatsen.toString(),
    Jobrole: Jobrole.transport_plaatsen,
    description: "Transport/Plaatsen",
    timeRegistrationTypes: [
      TimeRegistrationType.Vergadering,
      TimeRegistrationType.Werkbespreking,
      TimeRegistrationType.Planning,
      TimeRegistrationType.Transport,
      TimeRegistrationType.Overig,
      TimeRegistrationType.Reisuren,
      TimeRegistrationType.Schoonmaak,
      TimeRegistrationType.Studie,
    ],
  },
  {
    id: Jobrole.verhuur_projecten.toString(),
    Jobrole: Jobrole.verhuur_projecten,
    description: "Verhuur/Projecten",
    timeRegistrationTypes: [
      TimeRegistrationType.Vergadering,
      TimeRegistrationType.Werkbespreking,
      TimeRegistrationType.Planning,
      TimeRegistrationType.Projecten,
      TimeRegistrationType.Overig,
      TimeRegistrationType.Studie,
    ],
  },
  {
    id: Jobrole.facilitair.toString(),
    Jobrole: Jobrole.facilitair,
    description: "Facilitair",
    timeRegistrationTypes: [
      TimeRegistrationType.Vergadering,
      TimeRegistrationType.Werkbespreking,
      TimeRegistrationType.Bestellingen,
      TimeRegistrationType.Automatisering,
      TimeRegistrationType.Overig,
      TimeRegistrationType.Studie,
    ],
  },
  {
    id: Jobrole.voorman.toString(),
    Jobrole: Jobrole.voorman,
    description: "Voorman",
    timeRegistrationTypes: [
      TimeRegistrationType.Projecten,
      TimeRegistrationType.Werkbespreking,
      TimeRegistrationType.Overig,
      TimeRegistrationType.Studie,
    ],
  },
  {
    id: Jobrole.productie.toString(),
    Jobrole: Jobrole.productie,
    description: "Productie",
    timeRegistrationTypes: [
      TimeRegistrationType.Projecten,
      TimeRegistrationType.Werkbespreking,
      TimeRegistrationType.Overig,
      TimeRegistrationType.Studie,
    ],
  },
  {
    id: Jobrole.urencontrole.toString(),
    Jobrole: Jobrole.urencontrole,
    description: "Uren controle",
    timeRegistrationTypes: [
      TimeRegistrationType.Projecten,
      TimeRegistrationType.Werkbespreking,
      TimeRegistrationType.Overig,
      TimeRegistrationType.Studie,
    ],
  },
];



// WEBPACK FOOTER //
// ./src/enums/enums.ts